var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShareScreen = function SvgShareScreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.346,6.533L9.842,8.067L8.926,7.133L12,4l3.074,3.133l-0.916,0.934l-1.504-1.534v5.734h-1.308V6.533z M17.886,15.2 l1.046,3.267c0.13,0.4,0.065,0.8-0.13,1.066c-0.213,0.293-0.554,0.466-0.916,0.467H6.114c-0.392,0-0.719-0.2-0.915-0.467 c-0.196-0.333-0.262-0.666-0.131-1.066L6.114,15.2V9.333c0-0.4,0.262-0.666,0.654-0.666H8.73V10H7.422v4.667h9.156V10H15.27V8.667 h1.962c0.392,0,0.654,0.266,0.654,0.666V15.2z M10.692,16.667V18h2.616v-1.333H10.692z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShareScreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share-screen.e5a34137.svg";
export { ForwardRef as ReactComponent };